export const names = [
  'Aragorn II',
  'Arwen',
  'Flrond',
  'Celebrian',
  'Flrohir',
  'Flladan',
  'Turgon',
  'Flenwe',
  'Manwe',
  'Ulmo',
  'Aule',
  'Orome',
  'Mandos',
  'Irmo',
  'Tulkas',
  'Varda',
  'Yavanna',
  'Nienna',
  'Fste',
  'Vaire',
  'Vana',
  'Nessa',
  'Ingwe',
  'Ingil',
  'Indis',
  'Finwe',
  'Miriel',
  'Fingolfin',
  'Idril',
  'Tuor',
  'Farendil',
  'Flwing',
  'Galadriel',
  'Celeborn',
  'Galadhon',
  'Flmo',
  'Galathil',
  'Flros',
  'Vardamir',
  'Tindomiel',
  'Manwedil',
  'Atanalcar',
  'Tar-Amandil',
  'Vardilme',
  'Aulendil',
  'Nolondil',
  'Tar-Flendil',
  'Marien',
  'Farendur',
  'Caliondo',
  'Malantur',
  'Yavien',
  'Oromendil',
  'Axantur',
  'Cemendur',
  'Ardamir',
  'Lindisse',
  'Hallatan',
  'Irilde',
  'Finarfin',
  'Farwen',
  'Olwe',
  'Aegnor',
  'Angrod',
  'Orodreth',
  'Finrod',
  'Amarie',
  'Finduilas',
  'Gil-galad',
  'Fingon',
  'Aredhel',
  'Fol',
  'Maeglin',
  'Feanor',
  'Nerdanel',
  'Curufin',
  'Maedhros',
  'Maglor',
  'Celegorm',
  'Caranthir',
  'Amras',
  'Amrod',
  'Celebrimbor',
  'Nimloth',
  'Dior',
  'Beren',
  'Luthien',
  'Thingol',
  'Melian',
  'Daeron',
  'Beor',
  'Baran',
  'Boron',
  'Boromir',
  'Bregor',
  'Barahir',
  'Bregolas',
  'Belen',
  'Beldir',
  'Belemir',
  'Adanel',
  'Beren',
  'Fmeldir',
  'Baranor',
  'Bereg',
  'Andreth',
  'Beril',
  'Belegor',
  'Hirwen',
  'Arachon',
  'Gilwen',
  'Bregil',
  'Marach',
  'Malach',
  'Magor',
  'Hathol',
  'Hador',
  'Gloredhel',
  'Haldir',
  'Gildis',
  'Halmir',
  'Hareth',
  'Galdor',
  'Huor',
  'Rian',
  'Haldan',
  'Haldar',
  'Haldad',
  'Belegund',
  'Haleth',
  'Handir',
  'Beldis',
  'Brandir',
  'Hundar',
  'Hunleth',
  'Hundad',
  'Hardang',
  'Hurin',
  'Morwen',
  'Turin',
  'Nienor',
  'Lalaith',
  'Baragund',
  'Beleth',
  'Hiril',
  'Fnthor',
  'Meleth',
  'Agathor',
  'Hunthor',
  'Manthor',
  'Flured',
  'Flurin',
  'Imlach',
  'Amlach',
  'Durin',
  'Durin VI',
  'Nain I',
  'Thrain I',
  'Thorin I',
  'Gloin',
  'Oin',
  'Nain II',
  'Dain I',
  'Gror',
  'Nain',
  'Dain II',
  'Thorin III',
  'Durin VII',
  'Borin',
  'Farin',
  'Groin',
  'Oin',
  'Gloin',
  'Gimli',
  'Fundin',
  'Balin',
  'Dwalin',
  'Thror',
  'Fror',
  'Thrain II',
  'Frerin',
  'Thorin II',
  'Dis',
  'Fili',
  'Kili',
  'Silmarien',
  'Flatan',
  'Valandil',
  'Farendur',
  'Numendil',
  'Amandil',
  'Flendil',
  'Isildur',
  'Valandil',
  'Fldacar',
  'Arantar',
  'Tarcil',
  'Tarondor',
  'Valandur',
  'Flendur',
  'Farendur',
  'Amlaith',
  'Beleg',
  'Mallor',
  'Celepharn',
  'Celebrindor',
  'Malvegil',
  'Argeleb I',
  'Morgoth',
  'Frodo Baggins',
  'Arveleg I',
  'Araphor',
  'Argeleb II',
  'Arvegil',
  'Arveleg II',
  'Araval',
  'Araphant',
  'Arvedui',
  'Firiel',
  'Aranarth',
  'Arahael',
  'Aranuir',
  'Aravir',
  'Aragorn I',
  'Araglas',
  'Arahad I',
  'Aragost',
  'Aravorn',
  'Arahad II',
  'Arassuil',
  'Arathorn I',
  'Argonui',
  'Arador',
  'Arathorn II',
  'Gilraen',
  'Dirhael',
  'Ivorwen',
  'Gilbarcid',
  'Anarion',
  'Cemendur',
  'Farendil',
  'Anardil',
  'Ostoher',
  'Romendacil I',
  'Turambar',
  'Atanatar I',
  'Siriondil',
  'Tarannon',
  'Beruthiel',
  'Tarciryan',
  'Thorondur',
  'Aldarion',
  'Turambar',
  'Ciryon',
  'Tarandil',
  'Calimendi',
  'Tardil',
  'Tarostar',
  'Minalcar',
  'Ostoher',
  'Orodreth',
  'Fldathorn',
  'Fldarion',
  'Forodacil',
  'Farnil',
  'Ciryandil',
  'Hyarmendacil I',
  'Atanatar II',
  'Narmacil I',
  'Calmacil',
  'Romendacil II',
  'Valacar',
  'Vidumavi',
  'Fldacar',
  'Aldamir',
  'Ornendil',
  'Hyarmendacil II',
  'Minardil',
  'Telemnar',
  'Minastan',
  'Tarondor',
  'Telumehtar',
  'Narmacil II',
  'Calimehtar',
  'Ondoher',
  'Faramir',
  'Artamir',
  'Minohtar',
  'Arciryas',
  'Calimmacil',
  'Siriondil',
  'Farnil',
  'Farnur',
  'Vidugavia',
  'Marhari',
  'Marhwini',
  'Forthwini',
  'Frumgar',
  'Fram',
  'Leod',
  'Forl',
  'Brego',
  'Aldor',
  'Baldor',
  'Fofor',
  'Frea',
  'Freawine',
  'Goldwine',
  'Freca',
  'Wulf',
  'Deor',
  'Gram',
  'Helm',
  'Hild',
  'Hama',
  'Haleth',
  'Frealaf',
  'Brytta',
  'Walda',
  'Folca',
  'Folcwine',
  'Fengel',
  'Fastred',
  'Folcred',
  'Thengel',
  'Morwen',
  'Theoden',
  'Flfhild',
  'Theodwyn',
  'Eomund',
  'Theodred',
  'Fomer',
  'Lothiriel',
  'Flfwine',
  'Eowyn',
  'Faramir',
  'Flboron',
  'Barahir',
  'Fldarion',
  'Boromir',
  'Denethor II',
  'Finduilas',
  'Fcthelion II',
  'Turgon',
  'Turin II',
  'Thorondir',
  'Belecthor II',
  'Beregond',
  'Beren',
  'Fgalmoth',
  'Morwen',
  'Fcthelion I',
  'Orodreth',
  'Belecthor I',
  'Hurin II',
  'Hallas',
  'Cirion',
  'Boromir',
  'Denethor I',
  'Rian',
  'Dior',
  'Barahir',
  'Hador',
  'Turin I',
  'Hurin I',
  'Belegorn',
  'Herion',
  'Fradan',
  'Mardil',
  'Vorondil',
  'Pelendur',
  'Hurin',
  'Imrahil',
  'Ivriniel',
  'Adrahil II',
  'Frchirion',
  'Amrothos',
  'Flphir',
  'Angelimir',
  'Aglahad',
  'Galador',
  'Gilmith',
  'Imrazor',
  'Mithrellas',
  'Adrahil I',
  'Tar-Meneldur',
  'Almarian',
  'Veantur',
  'Tar-Aldarion',
  'Frendis',
  'Isilme',
  'Beregar',
  'Tar-Ancalime',
  'Hallacar',
  'Tar-Anarion',
  'Nessanie',
  'Tar-Surion',
  'Tar-Telperien',
  'Isilmo',
  'Tar-Minastir',
  'Tar-Ciryatan',
  'Tar-Atanamir',
  'Tar-Ancalimon',
  'Tar-Telemmaite',
  'Tar-Vanimelde',
  'Herulcamo',
  'Tar-Alcarin',
  'Tar-Calmacil',
  'Tar-Ardamin',
  'Gimilzagar',
  'Ar-Adunakhor',
  'Ar-Zimrathon',
  'Ar-Sakalthor',
  'Ar-Gimilzor',
  'Inzilbeth',
  'Tar-Palantir',
  'Gimilkhad',
  'Tar-Miriel',
  'Ar-Pharazon',
  'Lindorie',
  'Oropher',
  'Thranduil',
  'Legolas',
  'Bard II',
  'Brand',
  'Bain',
  'Bard I',
  'Girion',
  'Heden',
  'Foh',
  'Friol',
  'Cwen',
  'Naimi',
  'Heorrenda',
  'Horsa',
  'Hengest',
  'Beorn',
  'Grimbeorn',
  'Gothmog',
  'Telimektar',
  'Osse',
  'Uinen',
  'Isengrim Took II',
  'Isumbras Took III',
  'Ferumbras Took II',
  'Fortinbras Took I',
  'Gerontius Took',
  'Adamanta Chubb',
  'Bandobras Took',
  'Isumbras Took IV',
  'Fortinbras Took II',
  'Ferumbras Took III',
  'Hildigard Took',
  'Isengrim Took III',
  'Isembold Took',
  'Hildifons Took',
  'Isembard Took',
  'Flambard Took',
  'Adelard Took',
  'Reginard Took',
  'Fverard Took',
  'Hildibrand Took',
  'Sigismond Took',
  'Rosamunda Took',
  'Odovacar Bolger',
  'Fredegar Bolger',
  'Fstella Bolger',
  'Donnamira Took',
  'Hugo Boffin',
  'Belladonna Took',
  'Bungo Baggins',
  'Bilbo Baggins',
  'Hildigrim Took',
  'Rosa Baggins',
  'Adalgrim Took',
  'Paladin Took II',
  'Fglantine Banks',
  'Peregrin Took I',
  'Diamond Took',
  'Pervinca Took',
  'Pimpernel Took',
  'Pearl Took',
  'Faramir Took I',
  'Goldilocks Gardner',
  'Mirabella Took',
  'Gorbadoc Brandybuck',
  'Primula Brandybuck',
  'Drogo Baggins',
  'Mungo Baggins',
  'Laura Grubb',
  'Balbo Baggins',
  'Berylla Boffin',
  'Pansy Baggins',
  'Fastolph Bolger',
  'Belba Baggins',
  'Rudigar Bolger',
  'Longo Baggins',
  'Camellia Sackville',
  'Otho Sackville',
  'Lobelia Sackville',
  'Lotho Sackville',
  'Sancho Proudfoot',
  'Linda Baggins',
  'Bodo Proudfoot',
  'Odo Proudfoot',
  'Olo Proudfoot',
  'Ponto Baggins I',
  'Mimosa Bunce',
  'Polo Baggins',
  'Posco Baggins',
  'Ponto Baggins II',
  'Gilly Brownlock',
  'Porto Baggins',
  'Peony Baggins',
  'Milo Burrows',
  'Angelica Baggins',
  'Moro Burrows',
  'Myrtle Burrows',
  'Minto Burrows',
  'Mosco Burrows',
  'Dora Baggins',
  'Dudo Baggins',
  'Daisy Baggins',
  'Griffo Boffin',
  'Fosco Baggins',
  'Largo Baggins',
  'Tanta Hornblower',
  'Lily Baggins',
  'Togo Goodbody',
  'Samwise Gamgee',
  'Rose Cotton',
  'Flanor Gardner',
  'Fastred',
  'Frodo Gardner',
  'Holfast Gardner',
  'Harding',
  'Rose Gardner',
  'Merry Gardner',
  'Pippin Gardner',
  'Hamfast Gardner',
  'Daisy Gardner',
  'Primrose Gardner',
  'Bilbo Gardner',
  'Ruby Gardner',
  'Robin Gardner',
  'Tolman Gardner',
  'Hamfast Gamgee',
  'Bell Goodchild',
  'Daisy Gamgee',
  'Hamson Gamgee',
  'Halfred Gamgee',
  'May Gamgee',
  'Hobson',
  'Hob Gammidge',
  'Rowan',
  'Wiseman Gamwich',
  'Hamfast Gamwich',
  'May',
  'Andwise Roper',
  'Anson Roper',
  'Halfred Gamgee',
  'Halfred Greenhand',
  'Holman Greenhand',
  'Frling',
  'Hending',
  'Rose',
  'Holman',
  'Cotman',
  'Carl',
  'Cottar',
  'Holman Cotton',
  'Tolman Cotton',
  'Lily Brown',
  'Wilcome Cotton I',
  'Marigold Gamgee',
  'Tolman Cotton, Jr.',
  'Wilcome Cotton II',
  'Bowman Cotton',
  'Carl Cotton',
  'Saruman',
  'Gandalf',
  'Radagast',
  'Foenwe',
  'Sauron',
  'Arien',
  'Urwen',
  'Tilion',
  'Silmo',
  'Alatar',
  'Pallando',
  'Mim',
  'Ibun',
  'Khím',
  'Bór',
  'Borlad',
  'Borthand',
  'Borlach',
  'Marmadoc Brandybuck',
  'Adaldrida Bolger',
  'Madoc Brandybuck',
  'Hanna Goldworthy',
  'Gormadoc Brandybuck',
  'Malva Headstrong',
  'Gorhendad Oldbuck',
  'Sadoc Brandybuck',
  'Salvia Brandybuck',
  'Gundabald Bolger',
  'Rorimac Brandybuck',
  'Menegilda Goold',
  'Saradoc Brandybuck',
  'Fsmeralda Took',
  'Meriadoc Brandybuck',
  'Merimac Brandybuck',
  'Berilac Brandybuck',
  'Gundolpho Bolger',
  'Alfrida of the Yale',
  'Rudolph Bolger',
  'Cora Goodbody',
  'Gundahar Bolger',
  'Dina Diggle',
  'Buffo Boffin',
  'Ivy Goodenough',
  'Briffo Boffin',
  'Basso Boffin',
  'Herugar Bolger',
  'Jessamine Boffin',
  'Otto Offin',
  'Lavender Grubb',
  'Bosco Boffin',
  'Imin',
  'Iminye',
  'Tata',
  'Tatie',
  'Fnel',
  'Fnelye',
  'Filibert Bolger',
  'Poppy Chubb-Baggins',
  'Falco Chubb-Baggins',
  'Bingo Baggins',
  'Chica Chubb',
  'Adalbert Bolger',
  'Gerda Boffin',
  'Gruffo Boffin',
  'Uffo Boffin',
  'Sapphira Brockhouse',
  'Rudibert Bolger',
  'Amethyst Hornblower',
  'Adalgar Bolger',
  'Haldir',
  'Rumil',
  'Orophin',
  'Ithilbor',
  'Saeros',
  'Ciryon',
  'Aratan',
  'Flendur',
  'Findis',
  'Irime',
  'Glorfindel',
  'Argon',
  'Telchar',
  'Gamil Zirak',
  'Azaghal',
  'Fangluin',
  'Floi',
  'Loni',
  'Frar',
  'Nali',
  'Nar',
  'Smeagol',
  'Deagol',
  'Meneldil',
  'Ilmare',
  'Salmar',
  'Thorondor',
  'Great Fagle',
  'Gwaihir',
  'Landroval',
  'Mahtan',
  'Guilin',
  'Gwindor',
  'Gelmir',
  'Cirdan',
  'Lalia Clayhanger',
  'Asphodel Brandybuck',
  'Rufus Burrows',
  'Gundahad Bolger',
  'Amaranth Brandybuck',
  'Saradas Brandybuck',
  'Seredic Brandybuck',
  'Hilda Bracegirdle',
  'Doderic Brandybuck',
  'Ilberic Brandybuck',
  'Celandine Brandybuck',
  'Dodinas Brandybuck',
  'Dinodas Brandybuck',
  'Theobald Bolger',
  'Nina Lightfoot',
  'Wilibald Bolger',
  'Prisca Baggins',
  'Wilimar Bolger',
  'Heribald Bolger',
  'Nora Bolger',
  'Ruby Bolger',
  'Marroc Brandybuck',
  'Tosto Boffin',
  'Flfstan Fairbairn',
  'Firiel Fairbairn',
  'Beorn',
  'Bombur',
  'Bofur',
  'Bifur',
  'Aerandir',
  'Frellont',
  'Falathar',
  'Ailinel',
  'Almiel',
  'Soronto',
  'Orchaldor',
  'Hatholdir',
  'Nuneth',
  'Amdir',
  'Amroth',
  'Nimrodel',
  'Anborn',
  'Androg',
  'Andvir',
  'Angbor',
  'Asgon',
  'Dunhere',
  'Guthlaf',
  'Galmod',
  'Grima',
  'Garulf',
  'Grimbold',
  'Grim',
  'Gamling',
  'Gleowine',
  'Frkenbrand',
  'Ceorl',
  'Hama',
  'Horn',
  'Eothain',
  'Beleg',
  'Mablung',
  'Mablung',
  'Damrod',
  'Calimehtar',
  'Castamir',
  'Rumil',
  'Fltas',
  'Gilfanon',
  'Salgant',
  'Urthel',
  'Ulfang',
  'Ulfast',
  'Ulwarth',
  'Uldor',
  'Lenwe',
  'Denethor',
  'Galion',
  'Gorlim',
  'Filinel',
  'Angrim',
  'Dagnir',
  'Radhruin',
  'Dairuin',
  'Arthad',
  'Hathaldir',
  'Lindir',
  'Frestor',
  'Halbarad',
  'Duinhir',
  'Duilin',
  'Derufin',
  'Forlong',
  'Hirluin',
  'Golasgil',
  'Beregond',
  'Baranor',
  'Bergil',
  'Borlas',
  'Berelach',
  'Ioreth',
  'Hirgon',
  'Ingold',
  'Findegil',
  'Targon',
  'Hurin',
  'Ulbar',
  'Ibal',
  'Firiel',
  'Orontor',
  'Henderch',
  'Fgalmoth',
  'Galdor',
  'Fcthelion',
  'Duilin',
  'Penlod',
  'Rog',
  'Aranwe',
  'Voronwe',
  'Flemmakil',
  'Hendor',
  'Legolas',
  'Pengolodh',
  'Brandir',
  'Dorlas',
  'Avranc',
  'Widfara',
  'Sangahyando',
  'Angamaite',
  'Ori',
  'Nori',
  'Dori',
  'Meneldor',
  'Witch-king',
  'Herumor',
  'Fuinur',
  'Berenhardt',
  'Indor',
  'Aerin',
  'Brodda',
  'Annael',
  'Gelmir',
  'Arminas',
  'Gildor',
  'Michael Fischermann'
];
